import React from 'react';

import { connect } from  'react-redux';

import { Redirect, Link } from 'react-router-dom';

import {api,API_URL} from '../../actions/_request';
import swal from 'sweetalert2';
//libs
import Select , {Async}  from 'react-select';
import moment from 'moment';


import * as actions from '../../actions/balancegeneral';


import ReactTable from "react-table";
import "react-table/react-table.css";

import {
    Card, CardBlock,
    Button, ButtonGroup,
    InputGroup, InputGroupAddon, InputGroupButton,InputGroupText,
    Input,
    Badge,
    Row,
    CardTitle
} from 'reactstrap';

import {
    AreaChart, Area, BarChart, Bar,
    PieChart, Pie,
    XAxis, YAxis, CartesianGrid, Tooltip, Legend, Cell, Sector,
    ResponsiveContainer
} from 'recharts';

import { TabContent, TabPane, Nav, NavItem, NavLink, CardText, Col } from 'reactstrap';
import classnames from 'classnames';
import Fasearch from 'react-icons/lib/fa/search';
import FAprint from 'react-icons/lib/fa/print';
const {PropTypes} = React;

const CustomTooltip  = React.createClass({
  propTypes: {
    type: PropTypes.string,
    payload: PropTypes.array,
    label: PropTypes.string,
  },

  render() {
    const { active } = this.props;
    if (active) {
      const { payload, label,fill } = this.props;
      // style={{width: '100%', height: '280px'}}
      // console.log('propiedades grafica--->',this.props);
      return (
        <div className="custom-tooltip">
				{
				  payload.map((item, i) => 
				  <p className="label text-capitalize" style={{ 'color': ''+item.fill,'fontSize':'21px' }} >{`${item.name} : ${new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(item.value)}`}</p>
				  )
				}
                         
        </div>
      );
    }
    return null;
  }
});

const meses = [
	{label : 'Enero' , value : 1},
	{label : 'Febrero', value : 2},
	{label : 'Marzo', value : 3},
	{label : 'Abril' , value: 4},
	{label : 'Mayo' , value: 5},
	{label : 'Junio' , value: 6},
	{label : 'Julio' , value: 7},
	{label : 'Agosto' , value: 8},
	{label : 'Septiembre' , value: 9},
	{label : 'Octubre' , value: 10},
	{label : 'Noviembre' , value: 11},
	{label : 'Diciembre' , value: 12},
];

const filterCaseInsensitive = (filter, row) => {
            const id = filter.pivotId || filter.id;
            if (row[id] !== null){
                return (
                    row[id] !== undefined ?
                        String(row[id].toLowerCase()).includes(filter.value.toLowerCase())
                        :
                        true
                );
            }
        };

class BalanceGeneral extends React.Component{

	constructor(props){
		super(props)

		this.state = {
			data : {
				lista:[],
				
				grafica:[],
        total_ventas : 0,
        total_pagar  : 0,
        servicios    : 0,
        ventas       : 0,
        total        : 0,

			},
			 calis:[{ name:'mes', Utilidad: 29443.87, Meta: 140000}],
			 activeTab: '1',
			 buscar:0,
       tickets:[],
       mostrar_lista:false,
       tecnico_id:0,
       porcentaje_venta:0,
       porcentaje_servicio:0,
       anticipo:0,
       fecha_inicial : moment().format('Y-MM-DD'),
       fecha_final : moment().add(1, 'days').format('Y-MM-DD'),
			
		}
		this.toggle_tab= this.toggle_tab.bind(this);
		this.handleSelectChange= this.handleSelectChange.bind(this);
    this.handleInputChange= this.handleInputChange.bind(this);
		this.search= this.search.bind(this);
    this.lista_tickets= this.lista_tickets.bind(this);
    this.sumar= this.sumar.bind(this);
	}

  sumar(){
    let {porcentaje_venta,porcentaje_servicio,anticipo,data} = this.state;
    /*p.replace(regex, 'ferret')*/
    let comision_ventas= parseFloat(data.ventas.replace(',',''))*(parseFloat(porcentaje_venta)/100);
    let comision_servicios= parseFloat(data.servicios.replace(',',''))*(parseFloat(porcentaje_servicio)/100);
    let total_pagar=comision_ventas+comision_servicios;
    let total=total_pagar- parseFloat( anticipo);

    // console.log('porcentaje_venta--->',porcentaje_venta);
    // console.log('porcentaje_venta--->',parseFloat(porcentaje_venta)/100);
    // console.log('venta---',data.ventas);
    // console.log('parseo venta---',data.ventas.replace(',',''));
    // console.log('comision_ventas---',comision_ventas);


    data.comision_ventas= this.formateo(comision_ventas);
    data.comision_servicios= this.formateo(comision_servicios);
    data.total_pagar= this.formateo(total_pagar);
    data.total= this.formateo(total);
    this.setState({
                  data : data,

                 
                });

  }

  handleInputChange(event) {



    if(event === null) return;
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
       [name]: value
     },()=>{

      this.sumar();
     });

    
    
  }

  lista_tickets(){
    let self = this;
        api().get(`/tickets_distribucion_participaciones/${this.state.mes}/${this.state.ano}`)
            .then(function(response)
            {                  
                if(response.status === 200)
                { 
                       // console.log('response--------->',response.data)
                self.setState({
                  tickets : response.data,
                  mostrar_lista:true,
                });
                }

            });
  }


	handleSelectChange(select, name) {

        
        const value = select === null ? null : select.value;

        let index= this.state.users.findIndex(option => option.value == value);
       
        console.log('tecnico------->',this.state.users[index]);
       

        this.setState({
           
             
                [name]: value,
                porcentaje_servicio:this.state.users[index].servicios,
                porcentaje_venta:this.state.users[index].venta,
                buscar:0,
        
        });
    }

    actualizar_porcentajes=()=>{
    let self = this;
        api().get(`/actualizar_porcentajes_reporte_destajo/${this.state.tecnico_id}?servicio=${self.state.porcentaje_servicio}&venta=${self.state.porcentaje_venta} `)
            .then(function(response)
            {                  
                if(response.status === 200)
                { 
                      swal("Bien hecho!", "Se Actualizaron Los Porcentajes!", "success");
                      api().get(`/users_reporte_destajo`)
                      .then(function(response)
                      {                  
                          if(response.status === 200)
                          { 
                            let usuarios = response.data.users;
                            usuarios.unshift(
                            {
                              value:0,
                              label:'Todos',
                              servicios:response.data.general.porcentaje_servicios,
                              venta:response.data.general.porcentaje_venta
                            });
                            self.setState({
                              users : usuarios,
                            });
                          }

                      });
                }

            });
  }
	search(){
		let self = this;
		    api().get(`/reporte_destajo?user_id=${this.state.tecnico_id}&fecha_final=${this.state.fecha_final}&fecha_inicial=${this.state.fecha_inicial}&mes=${this.state.mes}&ano=${this.state.ano}&servicios=${self.state.porcentaje_servicio}&ventas=${self.state.porcentaje_venta} `)
            .then(function(response)
            {                  
                if(response.status === 200)
                { 
                       // console.log('response--------->',response.data)
                       self.setState({
				        	data : response.data,
				        	buscar:1,

				        },()=>{

      self.sumar();
     });
                }

            });
	}
	toggle_tab(tab) {
        if (this.state.activeTab !== tab) {
          this.setState({
            activeTab: tab
          });
        }
      }
	 componentDidMount(){


	  let self = this;

	 	    var fecha = new Date();
        var ano = fecha.getFullYear();
        let anos=[];

        let user= parseInt(this.props.auth.user.id);
        if(user==1||user==15|| user==9)
          user=0;

        for (var i = 5 ; i >= 0; i--) {
        	anos.unshift({label:(ano-i),value:(ano-i)});
        }



const numeroDia = new Date().getDay();

// console.log("Nombre de día de la semana: ", numeroDia);

var fecha_hoy=moment().format('Y-MM-DD');
var fecha_lunes=moment(fecha_hoy).format('Y-MM-DD');
if(numeroDia==0)
    fecha_lunes=moment(fecha_hoy).subtract(6, 'day').format('Y-MM-DD');
if(numeroDia>1)
    fecha_lunes=moment(fecha_hoy).subtract(numeroDia-1, 'day').format('Y-MM-DD');


  var fecha_domingo=moment(fecha_lunes).add(6,'day').format('Y-MM-DD');

  // console.log('fecha_lunes---->',fecha_lunes);
  // console.log('fecha_domingo---->',fecha_domingo);



        this.setState({
        	mes : parseInt(fecha.getMonth())+1,
        	ano:ano,
        	anos:anos,
          fecha_inicial : fecha_lunes,
          fecha_final : fecha_domingo,
         
        });

         api().get(`/users_reporte_destajo`)
            .then(function(response)
            {                  
                if(response.status === 200)
                { 
                
                       let usuarios = response.data.users;
                        usuarios.unshift(
                        {
                          value:0,
                          label:'Todos',
                          servicios:response.data.general.porcentaje_servicios,
                          venta:response.data.general.porcentaje_venta
                        });
                        self.setState({
                          users : usuarios,
                        });
                }

            });



            api().get(`/porcentajes_reporte_destajo/${user}`)
            .then(function(response)
            {                  
                if(response.status === 200)
                { 
                  let porcentajes = response.data;
                    console.log('porcentajes--->',porcentajes)

                   self.setState({
                          porcentaje_venta:porcentajes.ventas,
                          porcentaje_servicio:porcentajes.servicio,
                   });
                    api().get(`/reporte_destajo?user_id=${user}&fecha_final=${self.state.fecha_final}&fecha_inicial=${self.state.fecha_inicial}&mes=${parseInt(fecha.getMonth())+1}&ano=${ano}&servicios=${self.state.porcentaje_servicio}&ventas=${self.state.porcentaje_venta} `)
                    .then(function(response)
                    {                  
                      if(response.status === 200)
                      { 
                        // console.log('response--------->',response.data)
                        self.setState({
                          data : response.data,
                          tecnico_id:user,
                          buscar:1,

                        },()=>{

                          self.sumar();
                        });
                      }
                    });
                }

            });





       
        
        
    }

      formateo(value) {
     var decimals =  2;
     var  separators =[',', ",", '.'];
     var number = (parseFloat(value) || 0).toFixed(decimals);
    if (number.length <= (4 + decimals))
        return '$' +number.replace('.', separators[separators.length - 1]);
    var parts = number.split(/[-.]/);
    value = parts[parts.length > 1 ? parts.length - 2 : 0];
    var result = value.substr(value.length - 3, 3) + (parts.length > 1 ?
        separators[separators.length - 1] + parts[parts.length - 1] : '');
    var start = value.length - 6;
    var idx = 0;
    while (start > -3) {
        result = (start > 0 ? value.substr(start, 3) : value.substr(0, 3 + start))
            + separators[idx] + result;
        idx = (++idx) % 2;
        start -= 3;
    }
    return result;
}









	render(){

		let {mes,ano,data} = this.state;
		// console.log("tickets--->",this.state.data.tickets);

		let fecha_actual= new Date();

		let fecha_comprar= new Date(`${fecha_actual.getFullYear()}-${parseInt(fecha_actual.getMonth())+1}-01`);

		let fecha_reporte= new Date(`${ano}-${mes}-01`);

		let candado=true;
		if(fecha_comprar < fecha_reporte || (parseInt(fecha_comprar.getMonth())+1==mes&& fecha_comprar.getFullYear()==ano ) )
			candado=false;



		let user= 0;//parseInt(this.props.user.user,10);
		let rol=0;

		
        if (typeof(this.props.auth.user) !="undefined")
        {           
            user= parseInt(this.props.auth.user.id);
            rol= parseInt(this.props.auth.user.rol);
            // console.log('usuario----->',this.props.auth.user)
       }
		
		// console.log('fecha_reporte---->',fecha_reporte);


		return(
		<Card className="px-3">
			<div className="mb-2"></div>
			<Nav tabs>
				<NavItem>
					<NavLink className={classnames({ active: this.state.activeTab === '1' })}	onClick={() => { this.toggle_tab('1'); }}	>
						Reporte de producción a destajo
					</NavLink>
				</NavItem>
			</Nav>
			<TabContent activeTab={this.state.activeTab}>
				<TabPane tabId="1">
				 <div className="row mt-3">
         <div className="col-12 col-md-2"> 
              <div className="form-group">
                  <label >Inicio:</label>
                  <input  type="date" className="form-control" name="fecha_inicial" 
                    value={this.state.fecha_inicial} onChange={this.handleInputChange}/> 
              </div>
          </div>
          <div className="col-12 col-md-2"> 
              <div className="form-group">
                  <label >Final:</label>
                  <input  type="date" className="form-control" name="fecha_final" 
                    value={this.state.fecha_final} onChange={this.handleInputChange}/> 
              </div>
          </div>

                <div className="col-12 col-md-3"> 
                    <div className="form-group">
                        <label >Tecnico:</label>
                        <Select
                            placeholder=""
                            type="text"
                            name="tecnico_id"
                            options={this.state.users}
                            value={parseInt(this.state.tecnico_id) }
                            onChange={ (select) => { this.handleSelectChange(select, 'tecnico_id') } }
                            disabled ={rol!=4?true:false}
                            clearable={false}

                        />
                    </div>
                </div>
                <div className="col-12 col-md-4"> 
                    <div className="form-group">
                    					<label><br/></label><br/>
										<Button color='success' onClick={this.search}> <Fasearch/> </Button>	
                    </div>


                 </div>
                 <div className="col-12 col-md-2"> 
                    <div className="form-group">
                        <label >% Venta:</label>
                        <input  type="number" className="form-control" name="porcentaje_venta" 
                         readOnly={(user==1||user==15|| user==9)?false:true} value={this.state.porcentaje_venta} onChange={this.handleInputChange}/> 
                    </div>
                </div>
                <div className="col-12 col-md-2"> 
                    <div className="form-group">
                        <label >% Producción:</label>
                         <input  type="number" className="form-control" name="porcentaje_servicio" 
                         readOnly={(user==1||user==15|| user==9|| user==21)?false:true} value={this.state.porcentaje_servicio} onChange={this.handleInputChange}/> 
                    </div>
                </div>
                 { (user==15||user==9||user==1)&&
              <div className="col-12 col-md-2"> 
                    <div className="form-group">
                              <label><br/></label><br/>
                    <Button color='success' onClick={this.actualizar_porcentajes}> Actualizar %</Button>  
                    </div>
              </div>
                }
                { (user==15||user==9||user==1)&&
                <div className="col-12 col-md-2"> 
                    <div className="form-group">
                        <label >Anticipo:</label>
                         <input  type="number" className="form-control" name="anticipo" 
                         readOnly={(user==1||user==15|| user==9)?false:true} value={this.state.anticipo} onChange={this.handleInputChange}/> 
                    </div>
                </div>
              }
              

                </div>
                	
					<Row className='mt-3 mb-4'>
					<div className=" col-12 col-md-4"> 
						<div className="form-group">
							<label > <b>Total de ventas:</b> {data.ventas}</label>
						</div>
					</div>
					<div className=" col-12 col-md-4"> 
						<div className="form-group">
							<label > <b>Total produccion:</b> {data.servicios} </label>
						</div>
					</div>
          <div className=" col-12 col-md-4"> 
            <div className="form-group">
              <label > <b>Total:</b> {data.total_ventas} </label>
            </div>
          </div>
          <div className=" col-12 col-md-4"> 
            <div className="form-group">
              <label > <b>Comision Ventas:</b> {data.comision_ventas} </label>
            </div>
          </div>
          <div className=" col-12 col-md-4"> 
            <div className="form-group">
              <label > <b>Comision Servicios:</b> {data.comision_servicios} </label>
            </div>
          </div>
					<div className=" col-12 col-md-4"> 
						<div className="form-group">
							<label > <b>Total comision:</b> {data.total_pagar} </label>
						</div>
					</div>
          { (user==15||user==9||user==1)&&
            <div className=" col-12 col-md-4"> 
              <div className="form-group">
                <label > <b>Total a Pagar:</b> {data.total} </label>
              </div>
            </div>
          }
					
					
					</Row>



                  <div className="view-content view-components mt-3">
                    <Card>
                        <CardBlock>
                        <div className="row justify-content-end">
                       
                
                          
                        </div>
                            <ReactTable
                              data      = {this.state.data.tickets}
                              className = "-striped -highlight"
                              columns   = {[
                                {
                                    Header: '#',
                                    filterable: false,
                                    sortable: false,
                                    maxWidth:80,
                                    minWidth:80, 
                                    Cell: (row) =>
                                    {
                                        return(
                                            <div className="text-center">
                                                {parseInt(row.index)+1}                                                
                                            </div>
                                        )
                                    }
                                },
                                {Header: 'Fecha', accessor: 'fecha',maxWidth:180,minWidth:180 , style: { 'textAlign': 'left'}},
                                {Header: 'Tecnico', accessor: 'tecnico',maxWidth:150},
                                {Header: 'No.', accessor: 'clave',maxWidth:150},
                                {Header: 'Cliente', accessor: 'cliente'},       
                                {Header: 'Importe', accessor: 'subtotal',maxWidth:180,minWidth:180 , style: { 'textAlign': 'center'}}                      
                              ]}
                              filterable 
                              defaultPageSize={10} 
                              defaultFilterMethod={filterCaseInsensitive}
                              
                               SubComponent={ row => {
                                return(
                                    <Card>
                                        <CardBlock>
                                            <CardTitle className="h6 text-uppercase mb-4">Más Información</CardTitle>
                                            <table className="table">
                                              <thead>
                                                <tr>
                                                 
                                                  <th>Descripción</th> 
                                                  <th>Costo</th> 
                                                  <th>Importe</th> 
                                                                                             
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {
                                                  row.original.productos.map((item, i) => 
                                                  <tr key={i}>
                                                      <td>{item.descripcion}</td>  
                                                     <td>{this.formateo(item.costo)}</td>
                                                     <td>{this.formateo(item.subtotal)}</td>
                                                 
                                                  </tr>)
                                                }
                                              </tbody>
                                            </table>
                                        </CardBlock>
                                    </Card>

                                )
                              }}
                            />
                        </CardBlock>
                    </Card>
                </div>

   
					<br/>
					<br/>
					<br/>
					<br/>

				</TabPane>
			</TabContent>
		</Card>
		)
	}

}

function mapStateToProps(state, ownProps) {
    return {
        balancegeneral : state.balancegeneral,
        auth:state.auth
    }
};

export default connect(mapStateToProps, actions)(BalanceGeneral)


// WEBPACK FOOTER //
// ./src/views/reportes/ReporteDestajo.js